module.exports = __webpack_public_path__ + "img/pr-12.993b5bf4.png";